import { DomainSearchSuiteModule, TldPromotionPrice } from '@wix/domains-search-suite';
import { Box, Text } from '@wix/design-system';
import React from 'react';
import { PerceptionTldPrice } from '../TldPromotionBoxes/PerceptionTldPrice';
import { usePerceptionTldRow } from '../../pricingPerception';
import s from './perceptionTldSlots.scss';
const FREE_WITH_PLAN_KEY = 'domain_search_suite.domain_gate.tld_section.badge.free_with_plan';
const FREE_FIRST_YEAR = 'FREE_FIRST_YEAR';
export const PerceptionTldBadge = _ref => {
  var _usePerceptionTldRow;
  let {
    pricing,
    tld
  } = _ref;
  const {
    t: tSuite
  } = DomainSearchSuiteModule.internals.useTranslations();
  const labelKey = (_usePerceptionTldRow = usePerceptionTldRow(pricing, tld)) == null || (_usePerceptionTldRow = _usePerceptionTldRow.note) == null ? void 0 : _usePerceptionTldRow.labelKey;
  const showsFreeWithPlan = (pricing == null ? void 0 : pricing.pricingStrategy) === FREE_FIRST_YEAR;
  if (!labelKey && !showsFreeWithPlan) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    padding: "3px 6px",
    width: "max-content",
    backgroundColor: "#DFF994",
    borderRadius: "4px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal",
    className: s.badgeText
  }, tSuite(labelKey ?? FREE_WITH_PLAN_KEY)));
};
export const PerceptionTldPriceSlot = _ref2 => {
  let {
    pricing,
    tld
  } = _ref2;
  const perceptionRow = usePerceptionTldRow(pricing, tld);
  if (!pricing) {
    return null;
  }
  return perceptionRow ? /*#__PURE__*/React.createElement(PerceptionTldPrice, {
    pricing: pricing,
    row: perceptionRow
  }) : /*#__PURE__*/React.createElement(TldPromotionPrice, {
    pricing: pricing,
    tld: tld
  });
};
//# sourceMappingURL=PerceptionTldSlots.js.map